import React from 'react';
import gql from 'graphql-tag';
import { useApolloClient } from '@apollo/client';
import {
	MenuSuperiorTabs,
	LoadingSection
} from '../../UI';
import { moment } from '../../containers/App';
import PortalSectionsModal from './PortalSectionsModal';
import PortalRequiredAttachments from './PortalRequiredAttachments';
// import InputsInPortal from './InputsInPortal';
import ConfigPortalDates from './ConfigPortalDates';
import ConfigEmails from './ConfigEmails';
import ConfigModel from './ConfigModel';
import ConfigColors from './ConfigColors';
import ConfigLanguage from './ConfigLanguage';
import PortalStates from './PortalStates';
import PortalIndexAttachments from './PortalIndexAttachments';
import InputsInPortal from './InputsInPortal';
import MainPortalConfig from './MainPortalConfig';
import ConfigHome from './ConfigHome';
import PortalVoteSense from './PortalVoteSense';
import ConfigPortalText from './ConfigPortalText';


const CouncilPortalForm = ({
	translate,
	portal,
	refetch,
	loading
}) => {
	const {
		council,
		attachments,
		__typename,
		...data
	} = portal;
	const [state, setState] = React.useState(data);
	const [modal, setModal] = React.useState(false);
	const [selecteOptionMenu, setSelecteOptionMenu] = React.useState('Estado');
	const tabs = ['Estado', 'Fechas', 'Emails', 'Secciones', 'Sentido del Voto', 'Home', 'Campos necesarios', 'Información adicional', 'Documentos necesarios', 'Adjuntos', 'Idiomas', 'Preview', 'Colores', 'Traducciones'];
	const client = useApolloClient();

	const updatePortal = async value => {
		if (!state.name) {
			return;
		}
		const response = await client.mutate({
			mutation: gql`
                mutation UpdatePortal($portal: CouncilPortalInput!){
                    updateCouncilPortal(portal: $portal){
                        success
                        message
                    }
                }
            `,
			variables: {
				portal: {
					id: portal.id,
					...value
				}
			}
		});
		if (response?.data?.updateCouncilPortal?.success) {
			refetch();
		}
	};


	const updateAndSave = value => {
		setState({
			...state,
			...value
		});
		updatePortal(value);
	};

	return (
		<div style={{ height: '100%' }}>
			<div style={{ marginTop: '.5em', marginBottom: '1em' }}>
				<div style={{
					display: 'flex',
					padding: '1em',
					justifyContent: 'space-between',
					paddingTop: '0px',
					alignItems: 'center',
					paddingLeft: '0'
				}}>
					<div style={{
						display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%'
					}}>
						<div style={{ display: 'flex' }}>
							<div style={{ fontSize: '13px' }}>
								<MenuSuperiorTabs
									items={tabs}
									setSelect={setSelecteOptionMenu}
									selected={selecteOptionMenu}
									colorSelected={'#000000'}
								/>
							</div>
							<div style={{ marginLeft: '1.5rem' }}>
								{
									loading && <LoadingSection size="1.5rem" />
								}
							</div>
						</div>
						<div>
							{
								portal.lastEdited
								&& <p style={{ margin: 0 }}>
									<small style={{ fontSize: '0.8em', textAlign: 'right', whiteSpace: 'nowrap' }}>
										Última edición: {moment(portal.lastEdited).format('LLL')}
									</small>
								</p>
							}
						</div>
					</div>
				</div>
			</div>
			{selecteOptionMenu === 'Estado'
				&& <div style={{ height: '100%' }}>
					<PortalStates
						translate={translate}
						refetch={refetch}
						state={state}
						portal={portal}
						updateAndSave={updateAndSave}
					/>
				</div>
			}
			{
				selecteOptionMenu === 'Idiomas'
				&& <div style={{ height: '100%' }}>
					<ConfigLanguage
						portal={portal}
						translate={translate}
						updateState={newData => updateAndSave({
							config: {
								...portal.config,
								...newData
							}
						})}
					/>
				</div>
			}
			{selecteOptionMenu === 'Fechas'
				&& <div style={{ height: '100%' }}>
					<ConfigPortalDates
						translate={translate}
						portal={portal}
						updateState={newData => updateAndSave({
							config: {
								...portal.config,
								...newData
							}
						})}
					/>
				</div>
			}
			{
				selecteOptionMenu === 'Preview'
				&& <div style={{ height: '100%' }}>
					<ConfigModel
						portal={portal}
						translate={translate}
						updateState={newData => updateAndSave({
							config: {
								...portal.config,
								...newData
							}
						})}
					/>
				</div>
			}
			{
				selecteOptionMenu === 'Colores'
				&& <ConfigColors
					portal={portal}
					translate={translate}
					updateAndSave={newData => updateAndSave({
						config: {
							...portal.config,
							...newData
						}
					})}
				/>
			}
			{selecteOptionMenu === 'Emails'
				&& <div style={{ height: '100%' }}>
					<ConfigEmails
						translate={translate}
						portal={portal}
						updateState={newData => {
							updateAndSave({
								config: {
									...portal.config,
									...newData
								}
							});
						}
						}
					/>
				</div>
			}
			{selecteOptionMenu === 'Secciones'
				&& <div style={{ height: '100%' }}>
					<PortalSectionsModal
						updateState={newData => updateAndSave({
							sendRefuseConfirmation: newData.sendRefuseConfirmation,
							sendAcceptConfirmation: newData.sendAcceptConfirmation,
							config: {
								...portal.config,
								...newData.config,
							}
						})}
						translate={translate}
						portal={portal}
					/>
				</div>
			}
			{selecteOptionMenu === 'Sentido del Voto'
				&& <div style={{ height: '100%' }}>
					<PortalVoteSense
						updateState={newData => updateAndSave({
							config: {
								...portal.config,
								...newData.config,
							}
						})}
						translate={translate}
						portal={portal}
					/>
				</div>
			}
			{selecteOptionMenu === 'Home'
				&& <div style={{ height: '100%' }}>
					<ConfigHome
						translate={translate}
						portal={portal}
						updateState={newData => updateAndSave({
							config: {
								...portal.config,
								...newData
							}
						})}
					/>
				</div>
			}
			{selecteOptionMenu === 'Campos necesarios'
				&& <div style={{ height: '100%' }}>
					<InputsInPortal
						translate={translate}
						portal={portal}
						updateState={newData => updateAndSave({
							config: {
								...portal.config,
								...newData
							}
						})}
					/>
				</div>
			}
			{selecteOptionMenu === 'Información adicional'
				&& <div style={{ height: '100%' }}>
					<ConfigPortalText
						translate={translate}
						portal={portal}
						updateState={newData => updateAndSave({
							config: {
								...portal.config,
								...newData
							}
						})}
					/>
				</div>
			}
			{selecteOptionMenu === 'Documentos necesarios'
				&& <div style={{ height: '100%' }}>
					<PortalRequiredAttachments
						requestClose={() => setModal(false)}
						open={modal === 'requiredDocuments'}
						translate={translate}
						portal={portal}
						updateState={newData => updateAndSave({
							config: {
								...portal.config,
								...newData
							}
						})}
					/>
				</div>
			}
			{selecteOptionMenu === 'Adjuntos'
				&& <div style={{ height: '100%' }}>
					<PortalIndexAttachments
						portal={portal}
						translate={translate}
						refetch={refetch}
						updateAndSave={updateAndSave}
					/>
				</div>
			}
			{selecteOptionMenu === 'Traducciones'
				&& <div style={{ height: '100%' }}>
					<MainPortalConfig
						portal={portal}
						translate={translate}
						updateState={newData => updateAndSave({
							config: {
								...portal.config,
								...newData
							}
						})}
					/>
				</div>
			}
		</div>
	);
};


export default CouncilPortalForm;
